module.exports = __webpack_public_path__ + "media/assets/icons/arrow-up-8b0395a90a467bd8423d8084bf0ccef2.svg";